import { Skeleton } from 'primereact/skeleton';

export const SuspenseLoader = () => {
  return (
    <div className="flex size-full h-[inherit] shrink-0 flex-col gap-4 text-6xl">
      <Skeleton className="!h-1/4" />
      <Skeleton className="!h-3/4" />
    </div>
  );
};
